import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "dialog"]

  connect() {
    this.open()
  }

  open() {
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none")
    this.dialogTarget.classList.remove("opacity-0", "scale-95", "pointer-events-none")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none")
    this.dialogTarget.classList.add("opacity-0", "scale-95", "pointer-events-none")
    document.body.classList.remove("overflow-hidden")
  }
}
